/* OUD SIGNATURE — theme.js
   Reactive bottle (CONTEXT §6), splash (D-019), scroll reveals, header state.
   Touch is first-class: bottle drifts autonomously, gyro optional, never blocks. */
(function () {
  'use strict';

  /* ---------- Amiri gate: swap only pre-paint or under splash ---------- */
  var docEl = document.documentElement;
  var releaseWait = function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { docEl.classList.remove('amiri-wait'); });
    });
  };
  if (docEl.classList.contains('amiri-wait') && document.fonts && document.fonts.load) {
    document.fonts.load('1em Amiri').then(releaseWait, releaseWait);
  } else if (docEl.classList.contains('amiri-wait')) {
    releaseWait();
  }
  if (!docEl.classList.contains('amiri-ready') && document.fonts && document.fonts.load) {
    document.fonts.load('1em Amiri').then(function (faces) {
      if (!faces.length) return;
      try { sessionStorage.setItem('os-amiri', '1'); } catch (e) {}
      var splash = document.querySelector('.splash');
      var splashCovering = splash && !splash.classList.contains('is-done') && performance.now() < 1500;
      var painted = false;
      try {
        painted = performance.getEntriesByType('paint').some(function (e) {
          return e.name === 'first-contentful-paint';
        });
      } catch (e) { painted = true; }
      if (!painted || splashCovering) docEl.classList.add('amiri-ready');
      /* else: fallback stays this page; Amiri from the next page — no mid-view swap */
      document.fonts.load('700 1em Amiri');
      document.fonts.load('italic 1em Amiri');
    });
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Announcement marquee: duplicate copies out of the tab order ----------
     The ticker repeats the offer line; only the first copy should be reachable
     by keyboard — the aria-hidden duplicates' links must not be tab stops. */
  document.querySelectorAll('.announcement__item[aria-hidden] a').forEach(function (a) {
    a.tabIndex = -1;
  });

  /* ---------- Header: transparent over hero, solid after scroll ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var setHeader = function () {
      header.classList.toggle('is-solid', window.scrollY > 24);
    };
    window.addEventListener('scroll', setHeader, { passive: true });
    setHeader();
  }

  /* ---------- Cart quantity steppers + auto-update ---------- */
  (function () {
    var cartForm = document.querySelector('form[data-cart-form]');
    if (!cartForm) return;

    var updateButton = cartForm.querySelector('button[name="update"]');
    var updateTimer = null;
    if (!updateButton) return;

    var submitCart = function () {
      updateTimer = null;
      if (typeof cartForm.requestSubmit === 'function') {
        cartForm.requestSubmit(updateButton);
      } else {
        cartForm.submit();
      }
    };
    var queueUpdate = function () {
      if (updateTimer !== null) clearTimeout(updateTimer);
      updateTimer = setTimeout(submitCart, 500);
    };

    cartForm.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!button || !cartForm.contains(button)) return;

      var input = button.closest('.qty').querySelector('.qty-input');
      var quantity = parseInt(input.value, 10);
      var minimum = parseInt(input.min, 10);
      quantity = Number.isNaN(quantity) ? 0 : quantity;
      minimum = Number.isNaN(minimum) ? 0 : minimum;
      input.value = button.hasAttribute('data-qty-plus')
        ? quantity + 1
        : Math.max(minimum, quantity - 1);
      queueUpdate();
    });

    cartForm.addEventListener('change', function (event) {
      if (event.target.matches('.qty-input')) queueUpdate();
    });
    cartForm.addEventListener('submit', function () {
      if (updateTimer !== null) clearTimeout(updateTimer);
      updateTimer = null;
    });

    updateButton.hidden = true;
  })();

  /* ---------- Mobile sticky add to basket ---------- */
  (function () {
    var stickyAtc = document.querySelector('.sticky-atc');
    if (!stickyAtc || !('IntersectionObserver' in window)) return;

    var stickyButton = stickyAtc.querySelector('button[form]');
    var buyFormId = stickyButton && stickyButton.getAttribute('form');
    var buyForm = buyFormId ? document.getElementById(buyFormId) : null;
    if (!buyForm) return;

    var mobileAtc = window.matchMedia('(max-width: 1099px)');
    var formAboveViewport = false;

    if (reducedMotion) stickyAtc.style.transition = 'none';

    var updateStickyAtc = function () {
      var shown = mobileAtc.matches && formAboveViewport;
      stickyAtc.classList.toggle('is-shown', shown);
      stickyAtc.setAttribute('aria-hidden', shown ? 'false' : 'true');
      document.body.classList.toggle('sticky-atc-open', shown);
    };

    var stickyAtcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        formAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        updateStickyAtc();
      });
    }, { threshold: 0 });

    stickyAtcObserver.observe(buyForm);
    if (mobileAtc.addEventListener) {
      mobileAtc.addEventListener('change', updateStickyAtc);
    } else if (mobileAtc.addListener) {
      mobileAtc.addListener(updateStickyAtc);
    }
  })();

  /* ---------- Newsletter anchor ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="#newsletter"]');
    if (!link) return;

    setTimeout(function () {
      var footerEmail = document.querySelector('#footer-email');
      if (footerEmail) footerEmail.focus({ preventScroll: true });
    }, 0);
  });

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('newsletter-form')) {
      try { sessionStorage.setItem('newsletter-pending', String(Date.now())); } catch (err) {}
    }
  });

  (function () {
    // The /challenge page renders the theme layout (footer form included);
    // never reveal or consume the stamp there — the real landing page needs it.
    if (/^\/challenge/.test(location.pathname) || document.querySelector('.shopify-challenge__container')) { return; }

    var posted = /[?&]customer_posted=true/.test(location.search);
    var stamp = 0;
    try { stamp = Number(sessionStorage.getItem('newsletter-pending')); } catch (err) {}
    var fresh = stamp && Date.now() - stamp < 10 * 60 * 1000;
    if (stamp) { try { sessionStorage.removeItem('newsletter-pending'); } catch (err) {} }

    // Server-rendered outcome (success or error) wins — never double-render.
    var serverOutcome = document.querySelector(
      '.newsletter-form [role="status"]:not([hidden]), .newsletter-form [role="alert"]'
    );

    // Client-side fallback: Shopify's challenge redirect drops both the
    // customer_posted param and the referrer, so a fresh submit stamp is the
    // only signal that survives the round-trip.
    if (fresh && !serverOutcome) {
      document.querySelectorAll('.newsletter-form').forEach(function (form) {
        var thanks = form.querySelector('[data-newsletter-thanks]');
        if (!thanks) return;
        thanks.hidden = false;
        Array.prototype.forEach.call(form.children, function (el) {
          if (!el.hasAttribute('data-newsletter-thanks')) { el.hidden = true; }
        });
      });
      serverOutcome = document.querySelector('.newsletter-form [role="status"]:not([hidden])');
    }

    // Scroll the confirmation into view whichever path rendered it.
    if (serverOutcome && (fresh || posted)) { serverOutcome.scrollIntoView(); }

    // One-shot: drop the param so a refresh shows a fresh form.
    if (posted && window.history && history.replaceState) {
      var url = location.pathname + location.search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, '') + location.hash;
      history.replaceState(null, '', url);
    }
  })();

  /* ---------- Shared spring motion ---------- */
  var springEasing = function (stiffness, damping, mass) {
    var step = 0.001;
    var maxDuration = 2000;
    var restDelta = 0.001;
    var restVelocity = 0.001;
    var positions = [0];
    var velocities = [0];
    var position = 0;
    var velocity = 0;
    var i;

    for (i = 1; i <= maxDuration; i += 1) {
      var acceleration = (-stiffness * (position - 1) - damping * velocity) / mass;
      velocity += acceleration * step;
      position += velocity * step;
      positions.push(position);
      velocities.push(velocity);
    }

    var duration = maxDuration;
    var settledAfter = true;
    for (i = maxDuration; i >= 0; i -= 1) {
      var settled = Math.abs(positions[i] - 1) < restDelta &&
        Math.abs(velocities[i] * step) < restVelocity;
      settledAfter = settledAfter && settled;
      if (settledAfter) duration = i;
    }

    var sampleCount = 80;
    var samples = [];
    for (i = 0; i < sampleCount; i += 1) {
      var sampleTime = duration * i / (sampleCount - 1);
      var lowerIndex = Math.floor(sampleTime);
      var upperIndex = Math.min(Math.ceil(sampleTime), positions.length - 1);
      var sample = positions[lowerIndex] +
        (positions[upperIndex] - positions[lowerIndex]) * (sampleTime - lowerIndex);
      if (sample < 0 && sample > -0.0001) sample = 0;
      samples.push(i === sampleCount - 1 ? '1' : sample.toFixed(4));
    }

    return {
      easing: 'linear(' + samples.join(', ') + ')',
      duration: duration
    };
  };

  if (!reducedMotion && Element.prototype.animate) {
    var supportsLinear = false;
    try {
      document.createElement('div').animate(
        [{ opacity: 0 }, { opacity: 1 }],
        { duration: 1, easing: 'linear(0, 1)' }
      ).cancel();
      supportsLinear = true;
    } catch (e) {}

    var expandMotion = supportsLinear ? springEasing(150, 26, 1.05) : {
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      duration: 400
    };
    var collapseMotion = supportsLinear ? springEasing(190, 30, 1.1) : {
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      duration: 300
    };
    var expandFadeDuration = supportsLinear ? Math.round(expandMotion.duration * 0.6) : 400;
    var collapseFadeDuration = supportsLinear ? Math.round(collapseMotion.duration * 0.5) : 300;
  }

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.site-header__nav');
  if (navToggle && nav) {
    if (!expandMotion || !collapseMotion) {
      navToggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    } else {
      var navAnimation = null;
      var navOpacityAnimation = null;
      var navAnimationOpening = null;

      navToggle.addEventListener('click', function () {
        var opening = navAnimation ? !navAnimationOpening : !nav.classList.contains('is-open');
        var currentHeight = nav.getBoundingClientRect().height;
        var navStyles = navAnimation ? window.getComputedStyle(nav) : null;
        var currentOpacity = navStyles ? navStyles.opacity : (opening ? '0' : '1');

        if (navAnimation) navAnimation.cancel();
        if (navOpacityAnimation) navOpacityAnimation.cancel();
        navAnimation = null;
        navOpacityAnimation = null;
        navAnimationOpening = null;

        if (opening) nav.classList.add('is-open');
        nav.style.height = currentHeight + 'px';
        nav.style.overflow = 'hidden';

        var targetHeight = opening ? nav.scrollHeight : 0;
        nav.style.opacity = opening ? '1' : '0';
        navAnimation = nav.animate([
          { height: currentHeight + 'px' },
          { height: targetHeight + 'px' }
        ], {
          duration: opening ? expandMotion.duration : collapseMotion.duration,
          easing: opening ? expandMotion.easing : collapseMotion.easing
        });
        navAnimationOpening = opening;

        navOpacityAnimation = nav.animate(opening ? [
          { opacity: currentOpacity },
          { opacity: '1' }
        ] : [
          { opacity: currentOpacity },
          { opacity: '0' }
        ], {
          duration: opening ? expandFadeDuration : collapseFadeDuration,
          easing: supportsLinear ? 'ease-out' : 'cubic-bezier(0.4, 0, 0.2, 1)'
        });

        navToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');

        var activeAnimation = navAnimation;
        navAnimation.onfinish = function () {
          if (navAnimation !== activeAnimation) return;
          if (!opening) nav.classList.remove('is-open');
          nav.style.height = '';
          nav.style.overflow = '';
          nav.style.opacity = '';
          navAnimation = null;
          navOpacityAnimation = null;
          navAnimationOpening = null;
        };
      });
    }
  }

  /* ---------- Splash: once per session, skippable, ≤2s (D-019) ---------- */
  var splash = document.querySelector('.splash');
  if (splash) {
    var seen = false;
    try { seen = sessionStorage.getItem('os-splash') === '1'; } catch (e) {}
    if (seen || reducedMotion) {
      splash.classList.add('is-done');
    } else {
      try { sessionStorage.setItem('os-splash', '1'); } catch (e) {}
      var dismiss = function () { splash.classList.add('is-done'); };
      splash.addEventListener('click', dismiss);
      window.addEventListener('keydown', dismiss, { once: true });
      window.addEventListener('scroll', dismiss, { once: true, passive: true });
      setTimeout(dismiss, 1700); /* animation ends at ~1.7s regardless */
    }
  }

  /* ---------- Reactive bottle ---------- */
  var stages = document.querySelectorAll('[data-bottle-stage]');
  stages.forEach(function (stage) {
    var bottle = stage.querySelector('.bottle');
    if (!bottle) return;

    if (reducedMotion) return; /* static presentation */

    var fine = window.matchMedia('(pointer: fine)').matches;
    var raf = null;
    var target = { x: 0, y: 0 };

    var apply = function () {
      raf = null;
      bottle.style.setProperty('--mx', target.x.toFixed(3));
      bottle.style.setProperty('--my', target.y.toFixed(3));
    };
    var queue = function () { if (!raf) raf = requestAnimationFrame(apply); };

    if (fine) {
      /* Desktop: pointer drives tilt + brass rim light */
      window.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var cx = r.left + r.width / 2;
        var cy = r.top + r.height / 2;
        target.x = Math.max(-1, Math.min(1, (e.clientX - cx) / (window.innerWidth / 2)));
        target.y = Math.max(-1, Math.min(1, (e.clientY - cy) / (window.innerHeight / 2)));
        bottle.classList.remove('is-idle');
        queue();
      }, { passive: true });
      bottle.classList.add('is-idle');
    } else {
      /* Touch: JS-driven drift so tilt AND the --mx/--my rim light move together
         (the old CSS keyframes only swayed the transform, leaving the brass
         light frozen). Two unequal periods give an organic lissajous wander.
         Gyroscope still takes over where it fires without a permission prompt. */
      var gyro = false;
      var visible = true;
      var t0 = null;
      var drift = function (now) {
        if (gyro) return;
        if (!visible) { t0 = null; return; }
        if (t0 === null) t0 = now;
        var t = (now - t0) / 1000;
        target.x = Math.sin(t * (Math.PI * 2 / 5.5)) * 0.85;
        target.y = Math.cos(t * (Math.PI * 2 / 7.3)) * 0.3;
        apply();
        requestAnimationFrame(drift);
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var wasVisible = visible;
          visible = entries[0].isIntersecting;
          if (visible && !wasVisible && !gyro) requestAnimationFrame(drift);
        }).observe(stage);
      }
      requestAnimationFrame(drift);
      if (window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission !== 'function') {
        window.addEventListener('deviceorientation', function (e) {
          if (e.gamma === null) return;
          gyro = true;
          target.x = Math.max(-1, Math.min(1, e.gamma / 30));
          target.y = Math.max(-1, Math.min(1, (e.beta - 45) / 30));
          queue();
        }, { passive: true });
      }
    }
  });

  /* ---------- Load skeletons ---------- */
  var skeletons = document.querySelectorAll('[data-skeleton]');
  skeletons.forEach(function (box) {
    var img = box.querySelector('img');
    function done() { box.classList.add('is-loaded'); }
    if (!img) { done(); return; }
    if (img.complete && img.naturalWidth > 0) { done(); return; }
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  });

  /* Judge.me may never load (app not yet installed) — stop shimmering after 5s */
  var jdgmWidgets = document.querySelectorAll('.jdgm-review-widget');
  if (jdgmWidgets.length) {
    setTimeout(function () {
      jdgmWidgets.forEach(function (w) { w.classList.add('skeleton-off'); });
    }, 5000);
  }

  /* ---------- Scroll reveals ---------- */
  // Policy pages use Shopify's fixed markup — no Liquid access, so tag it here.
  // Descend into wrapper divs (privacy policy nests everything in one), and
  // never tag blocks taller than ~60% of the viewport: the observer's 0.15
  // threshold can't fire for huge blocks, which would leave them invisible
  // (terms of service is one giant <p>).
  var policyBody = document.querySelector('.shopify-policy__body');
  if (policyBody) {
    var policyTitle = document.querySelector('.shopify-policy__title h1');
    var policyBlocks = [];
    var collectPolicyBlocks = function (node) {
      Array.prototype.forEach.call(node.children, function (el) {
        if (el.tagName === 'DIV' && el.children.length > 1) {
          collectPolicyBlocks(el);
        } else {
          policyBlocks.push(el);
        }
      });
    };
    collectPolicyBlocks(policyBody.querySelector('.rte') || policyBody);
    var policyMaxHeight = window.innerHeight * 0.6;
    // Shopify's boilerplate terms of service is one giant <p> with sections
    // separated by <br><br>. Split those into real paragraphs so each section
    // can reveal on its own; anything still too tall stays untagged (visible).
    var brSplit = /(?:\s*<br[^>]*>\s*){2,}/i;
    var trimBr = /^(?:\s|<br[^>]*>)+|(?:\s|<br[^>]*>)+$/gi;
    var splitBlocks = [];
    policyBlocks.forEach(function (el) {
      if (el.tagName === 'P' && el.getBoundingClientRect().height > policyMaxHeight && brSplit.test(el.innerHTML)) {
        el.innerHTML.split(new RegExp(brSplit.source, 'gi')).forEach(function (segment) {
          segment = segment.replace(trimBr, '');
          if (!segment) return;
          var p = document.createElement('p');
          p.innerHTML = segment;
          el.parentNode.insertBefore(p, el);
          splitBlocks.push(p);
        });
        el.parentNode.removeChild(el);
      } else {
        splitBlocks.push(el);
      }
    });
    var policyTargets = splitBlocks.filter(function (el) {
      return el.getBoundingClientRect().height <= policyMaxHeight;
    });
    if (policyTitle) policyTargets.unshift(policyTitle);
    // The page is already committed with this text visible, so adding .reveal
    // normally would itself start a fade-out that .is-visible then retargets a
    // frame later — no visible animation. Snap to the hidden state with
    // transitions off, commit it, then restore so the reveal animates from a
    // committed opacity: 0.
    policyTargets.forEach(function (el) {
      el.style.transition = 'none';
      el.classList.add('reveal');
    });
    void policyBody.offsetHeight;
    policyTargets.forEach(function (el) { el.style.transition = ''; });
  }
  var revealables = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && !reducedMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Entrance stagger (--reveal-i) is for the initial batch only —
          // anything revealed by later scrolling should fade immediately.
          if (performance.now() > 2500) entry.target.style.transitionDelay = '0ms';
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -5% 0px' });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- FAQ accordion ---------- */
  if (!reducedMotion && Element.prototype.animate) {
    var faqItems = document.querySelectorAll('details.faq-item');
    faqItems.forEach(function (item) {
      var summary = item.querySelector('summary');
      var body = item.querySelector('.faq-item__body');
      var detailsAnimation = null;
      var bodyAnimation = null;
      var animationOpening = null;
      var pendingFrame = null;

      if (!summary) return;

      var borderHeight = function () {
        var itemStyles = window.getComputedStyle(item);
        return parseFloat(itemStyles.borderTopWidth) +
          parseFloat(itemStyles.borderBottomWidth);
      };

      var collapsedHeight = function () {
        return summary.getBoundingClientRect().height + borderHeight();
      };

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (pendingFrame !== null) {
          cancelAnimationFrame(pendingFrame);
          pendingFrame = null;
        }

        var opening = detailsAnimation ? !animationOpening : !item.open;
        var currentHeight = item.getBoundingClientRect().height;
        var bodyStyles = body && bodyAnimation ? window.getComputedStyle(body) : null;
        var bodyOpacity = bodyStyles ? bodyStyles.opacity : (opening ? '0' : '1');

        if (detailsAnimation) detailsAnimation.cancel();
        if (bodyAnimation) bodyAnimation.cancel();
        detailsAnimation = null;
        bodyAnimation = null;
        animationOpening = null;

        item.style.height = currentHeight + 'px';
        item.style.overflow = 'hidden';

        var targetHeight;
        if (opening) {
          item.classList.remove('is-closing');
          item.setAttribute('open', '');
          targetHeight = item.scrollHeight + borderHeight();
          if (body) body.style.opacity = '0';
        } else {
          item.classList.add('is-closing');
          targetHeight = collapsedHeight();
        }

        var startAnimations = function () {
          pendingFrame = null;
          detailsAnimation = item.animate([
            { height: currentHeight + 'px' },
            { height: targetHeight + 'px' }
          ], {
            duration: opening ? expandMotion.duration : collapseMotion.duration,
            easing: opening ? expandMotion.easing : collapseMotion.easing
          });
          animationOpening = opening;

          if (body) {
            body.style.opacity = opening ? '1' : '0';
            bodyAnimation = body.animate(opening ? [
              { opacity: '0' },
              { opacity: '1' }
            ] : [
              { opacity: bodyOpacity },
              { opacity: '0' }
            ], {
              duration: opening ? expandFadeDuration : collapseFadeDuration,
              easing: supportsLinear ? 'ease-out' : 'cubic-bezier(0.4, 0, 0.2, 1)'
            });
          }

          var activeAnimation = detailsAnimation;
          detailsAnimation.onfinish = function () {
            if (detailsAnimation !== activeAnimation) return;
            if (!opening) item.removeAttribute('open');
            item.classList.remove('is-closing');
            item.style.height = '';
            item.style.overflow = '';
            if (body) body.style.opacity = '';
            detailsAnimation = null;
            bodyAnimation = null;
            animationOpening = null;
          };
        };

        if (opening) {
          pendingFrame = requestAnimationFrame(startAnimations);
        } else {
          startAnimations();
        }
      });
    });
  }

  /* ---------- Contact form: char counter + submission ---------- */
  var contactForm = document.querySelector('#contact-form');
  if (contactForm) {
    var cBody = contactForm.querySelector('#c-body');
    var cCount = contactForm.querySelector('#c-body-count');
    if (cBody && cCount) {
      var cMax = cBody.getAttribute('maxlength') || 500;
      var updateCount = function () { cCount.textContent = cBody.value.length + ' / ' + cMax; };
      cBody.addEventListener('input', updateCount);
      updateCount();
    }
    var cHp    = contactForm.querySelector('input[name="botcheck"]');
    var cTurnstile = contactForm.querySelector('.cf-turnstile');
    var cConfirm = document.querySelector('#contact-confirm');
    var cError = document.querySelector('#contact-error');
    var cBtn   = contactForm.querySelector('button[type="submit"]');

    var resetTurnstile = function () {
      if (typeof window.turnstile !== 'undefined' && typeof window.turnstile.reset === 'function') {
        window.turnstile.reset();
      }
    };

    var showContactError = function () {
      if (cBtn) { cBtn.disabled = false; }
      if (cConfirm) { cConfirm.hidden = true; }
      if (cError) { cError.hidden = false; }
      resetTurnstile();
    };

    contactForm.addEventListener('submit', function (e) {
      if (cHp && cHp.checked) { e.preventDefault(); return; } // honeypot
      if (typeof contactForm.checkValidity === 'function' && !contactForm.checkValidity()) {
        return; // native validation UI
      }
      e.preventDefault();

      var action = contactForm.getAttribute('action');
      if (!window.fetch || !window.FormData || !action || !cTurnstile) {
        showContactError();
        return;
      }

      if (cBtn) { cBtn.disabled = true; }
      if (cConfirm) { cConfirm.hidden = true; }
      if (cError) { cError.hidden = true; }
      fetch(action, { method: 'POST', body: new FormData(contactForm) })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok || json.ok !== true) { throw new Error('Contact form submission failed'); }
          });
        })
        .then(function () {
          if (cConfirm) { cConfirm.hidden = false; }
          if (cBtn) { cBtn.disabled = false; }
          contactForm.reset();
          if (cBody && cCount) { cCount.textContent = '0 / ' + cMax; }
          resetTurnstile();
        })
        .catch(showContactError);
    });
  }
})();
